import React from "react";

import { BoolCheck } from "../BoolCheck";
import { Date } from "../Date";
import { OrganizationLink, TrackLink, UserLink } from "../DocumentLink";
import { DocumentTable } from "../DocumentTable";
import NoDataMessage from "../../common/NoDataMessage";
import { TrackWithDetails } from "../../common/apiTypes";

type TracksTableProps = {
  tracks: TrackWithDetails[];
};

export const TracksTable: React.FunctionComponent<TracksTableProps> = (
  props: TracksTableProps,
) => {
  const properties = [
    {
      title: "Track ID",
      render: (d: TrackWithDetails) => <TrackLink docId={d._id} />,
    },
    {
      title: "Title",
      render: (d: TrackWithDetails) => d.title,
    },
    {
      title: "Org ID",
      render: (d: TrackWithDetails) => <OrganizationLink docId={d.orgId} />,
    },
    {
      title: "Sender ID",
      render: (d: TrackWithDetails) =>
        d.userId ? <UserLink docId={d.userId}>{d.author}</UserLink> : d.author,
    },
    {
      title: "Sender Name",
      render: (d: TrackWithDetails) => d.authorName,
    },
    {
      title: "Active",
      render: (d: TrackWithDetails) => <BoolCheck check={d.active} />,
    },
    {
      title: "Deleted",
      render: (d: TrackWithDetails) => <BoolCheck check={d.deleted} />,
    },
    {
      title: "Original Send",
      render: (d: TrackWithDetails) => <Date date={d.originalNextBriefDate} />,
    },
    {
      title: "Next Send",
      render: (d: TrackWithDetails) => <Date date={d.nextBriefDate} />,
    },
    {
      title: "Send by DM",
      render: (d: TrackWithDetails) => <BoolCheck check={d.dmAppeal} />,
    },
    {
      title: "Question Count",
      render: (d: TrackWithDetails) => d.numTrackPolls,
    },
  ];

  if (!props.tracks.length) {
    return <NoDataMessage componentName="tracks" />;
  }

  return (
    <DocumentTable<TrackWithDetails>
      properties={properties}
      objects={props.tracks}
    />
  );
};
